import { getCurrentInstance } from '@vue/composition-api';

/**
 * Obtém a instância actual de vue, de forma a tornar o acesso
 * ao router & store mais simples.
 *
 * @since 1.0.0
 * @category Vue
 * @returns {Object} retorna uma instância de vue
 *
 */
const getRuntimeVM = () => {
    const vm = getCurrentInstance().proxy;
    if ( vm )
        return vm;

    throw new ReferenceError( '[vue-hooks] Not found vue instance.' );
};

export default getRuntimeVM;